// React
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

// Actions
import { initialStateSpace } from "../../../../redux/actions/reservations/space/fetchSpace";
import { fetchSpaceLogs } from "../../../../redux/actions/reservations/space/fetchSpacesLogs";
import { fetchSpaceListCustom, initialStateSpaceListCustom } from "../../../../redux/slices/custom/reservations/cruise/space/customSpaceList.slice";
import { findRatesForSpace, initialStateFindRatesForSpace } from "../../../../redux/slices/custom/reservations/cruise/space/findRatesForSpace.slice";
import { updateSpace } from "../../../../redux/actions/reservations/space/updateSpace";

// Components
import HeaderCatalog from "../../../../components/headerCatalog";
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";
import PassengerCell from "../../../../components/space/passengerCell";
import PassengerCellCanceledSpace from "../../../../components/space/passengerCellCanceledSpace";
import FlightCell from "../../../../components/space/flightCell";
import FlightCellCanceledSpace from "../../../../components/space/flightCellCanceledSpace";
import DiscountCell from "../../../../components/space/discountCell";
import StateCell from "../../../../components/space/stateCell";
import CancelSpaceModal from "../../../../components/space/cancelSpaceModal";
import LogsHistory from "../../../../components/reservation/logsHistory";

// UI
import { Table, Loader, Button, Icon, Breadcrumb, Divider, Accordion, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import SelectedRateSpaceModal from "../../../../components/space/SelectedRateSpaceModal";

// Resources
import { scrollToTop } from "../../../resources/utils";
import { Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

export default function SpaceList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openHistory, setOpenHistory] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mainFormData, setMainFormData] = useState(null);
  const [spaceId, setSpaceId] = useState('');
  let { cruise_id } = useParams();
  let { reservation_id } = useParams();
  let { booking_id } = useParams();
  const findRatesState = useSelector((state) => state.findRatesForSpace);
  const spaceStateCustom = useSelector((state) => state.customSpaceList)
  const spaceState = useSelector((state) => state.spaceReducer);
  const spaceLogState = useSelector((state) => state.spaceLogReducer)

  const user = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    dispatch(fetchSpaceListCustom(booking_id, cruise_id, reservation_id));
    scrollToTop();
    return () => {
      dispatch(initialStateSpaceListCustom());
      dispatch(initialStateFindRatesForSpace());
    };
  }, []);

  const onSubmitMainForm = (space) => {
    setMainFormData(space);
    setIsModalOpen(true);
    setSpaceId(space.id);
    const query = (`?cabin_id=${spaceStateCustom.booking.cabin_id}&&gender_id=${space.gender_id}&&contract_rate=${spaceStateCustom.reservation.contract_rate}`)
    dispatch(findRatesForSpace(reservation_id, booking_id, query))
  };

  const onSubmit = (data) => {
    const combinedData = { ...mainFormData, ...data };
    combinedData["cruise_id"] = cruise_id;
    combinedData["cabin_id"] = spaceStateCustom.booking.cabin_id;
    combinedData["single"] = spaceStateCustom.booking.single;
    combinedData["contract_rate"] = spaceStateCustom.reservation.contract_rate;
    combinedData["reservation_id"] = reservation_id;
    combinedData["booking_id"] = booking_id;
    dispatch(updateSpace(spaceId, combinedData));
    setIsModalOpen(false);
  };

  if (spaceState.fetching || spaceStateCustom.fetching) {
    return <Loader active inline />;
  }

  if (spaceStateCustom.processing) {
    return <Loader active inline />;
  }

  if (spaceState.message === "resource canceled successfully") {
    dispatch(fetchSpaceListCustom(booking_id, cruise_id, reservation_id));
    dispatch(fetchSpaceLogs(booking_id));
    dispatch(initialStateSpace());
  }

  if (spaceState.message === "resource deleted successfully") {
    dispatch(fetchSpaceListCustom(booking_id, cruise_id, reservation_id));
    dispatch(fetchSpaceLogs(booking_id));
    dispatch(initialStateSpace());
  }

  if (spaceState.message === "resource updated successfully") {
    dispatch(fetchSpaceListCustom(booking_id, cruise_id, reservation_id));
    dispatch(fetchSpaceLogs(booking_id));
    dispatch(initialStateSpace());
  }

  const handleHistoyClick = () => {
    setOpenHistory(!openHistory);
    if (!openHistory) {
      dispatch(fetchSpaceLogs(booking_id));
    }
  };

  return (
    <>
      {spaceState.error ? (
        <Message negative content={t(spaceState.error)} />
      ) : (
        ""
      )}
      <Breadcrumb>
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/cruise-detail`} className="section">{spaceStateCustom.cruise.code}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations`} className="section"> {t("reservation_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`} className="section">{t("cabin_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active> {t("cabin_cabin")} {spaceStateCustom.booking.cabin_name}</Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active> {t("space_title")}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />

      <HeadDetail yacht_name={spaceStateCustom.cruise.yacht_name} cruise_name={spaceStateCustom.cruise.name} itinerary_name={spaceStateCustom.cruise.itinerary_name} start_date={spaceStateCustom.cruise.start_date_format} end_date={spaceStateCustom.cruise.end_date_format} />
      <HeadDetailReservation reservation_date={spaceStateCustom.reservation.creation_date} reservation_agency={spaceStateCustom.reservation.agency_name} reservation_executive={spaceStateCustom.reservation.user} reservation_type={spaceStateCustom.reservation.cruise_type} />

      <br></br>

      <HeaderCatalog title={t("space_title")} message={spaceStateCustom.message} to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces_new`} />
      <Table color="blue" striped>
        <Table.Header>
          <Table.Row verticalAlign="top" align="center">
            <Table.HeaderCell>{t("space_code")}<br /></Table.HeaderCell>
            <Table.HeaderCell>{t("space_executive")}<br /></Table.HeaderCell>
            <Table.HeaderCell>{t("space_creation_date")}<br /><span className="text_date_format">(dd-mm-yyyy)</span></Table.HeaderCell>
            <Table.HeaderCell>{t("space_passenger")}<br /></Table.HeaderCell>
            <Table.HeaderCell>Crucero<br /><span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Comisión<br /><span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>{t("space_flight")}<br /></Table.HeaderCell>
            <Table.HeaderCell>Descuento Adicional <br /><span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Total<br /><span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {spaceStateCustom.spaces.map((space) => (
            <Table.Row align="center" key={space.id}>
              <Table.Cell className="font-semibold flex flex-col">
                {space.id}
                <span className="text_date_format uppercase"><StateCell space={space} /></span>
                <span className="text_date_format  uppercase">{space.include_flight_ticket ? 'Incluye ticket aereo' : 'No Incluye ticket aereo'}</span>
              </Table.Cell>
              <Table.Cell>{space.user}</Table.Cell>
              <Table.Cell>{space.creation_date}</Table.Cell>
              <Table.Cell><PassengerCell space={space} cruise_id={cruise_id} reservation_id={reservation_id} booking_id={booking_id} /></Table.Cell>

              <Table.Cell>{space.price}
                <br /><span className="text_date_format uppercase">{space.rate}</span>
                {space.tour_leader ? <> <br /><span className="text_date_format uppercase">Tour Leader</span></> : ''}
              </Table.Cell>
              <Table.Cell>-  {space.commission_price}<br /><span className="text_date_format">{space.commission_percentage}%</span></Table.Cell>
              <Table.Cell >
                <div className="relative group w-max cursor-pointer text-center">
                  <div className="flex gap-1 justify-center items-center">
                    <p className={`${space.include_flight_ticket ? "line-through" : ''} m-0 `} >
                      {(!space.space_flight_ticket && !space.include_flight_ticket && ['2'].includes(space.flight_count)) ? 'N/A' : space.flight_price}
                    </p>
                    <Icon name='warning' color='red' size='small' circular />
                  </div>
                  {space.tour_conductor ? <span className="text_date_format uppercase">Tour Conductor</span> : ''}
                  <div class="z-10 absolute w-[300px] left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none">
                    {['0','1'].includes(space.flight_count) && !space.include_flight_ticket && space.space_flight_ticket ? t('pending_airline_ticket_message')
                      : space.include_flight_ticket ? t('airline_ticket_included_message')
                      : space.space_flight_ticket ? t('airline_ticket_issued_by_company_message')
                      : t('airline_ticket_not_issued_by_company_message')}
                  </div>
                </div>
                <FlightCell space={space} cruise_id={cruise_id} reservation_id={reservation_id} booking_id={booking_id} />
              </Table.Cell>
              <Table.Cell ><DiscountCell space={space} user={user} /><br /></Table.Cell>
              <Table.Cell align="left"><b><div style={{ color: "#1261A0" }}>{space.total_price}</div></b><span className="text_date_format">Operadora: {space.operator_price}</span></Table.Cell>
              <Table.Cell>
                {spaceStateCustom.booking.family_room || spaceStateCustom.reservation.charter || spaceStateCustom.reservation.contract_rate || spaceStateCustom.reservation.ikarus_rate ?
                  ''
                  :
                  <Button className="add_button" icon onClick={() => onSubmitMainForm(space)}>
                    <Icon className="icon_color" name="dollar sign" />
                  </Button>
                }
                <Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces/${space.id}`}>
                  <Button className="edit_button" icon>
                    <Icon className="icon_color" name="pencil alternate" />
                  </Button>
                </Link>
                <CancelSpaceModal space={space} cruiseId={cruise_id} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body >
      </Table >

      <span style={{ fontWeight: "bold", fontSize: "18px", color: "red" }}>{t("space_canceled")}</span>
      <Table color="blue" striped>
        <Table.Header>
          <Table.Row align="center">
            <Table.HeaderCell>{t("space_code")}<br /></Table.HeaderCell>
            <Table.HeaderCell>{t("space_executive")}<br /></Table.HeaderCell>
            <Table.HeaderCell>{t("space_creation_date")}<br /><span className="text_date_format">(dd-mm-yyyy)</span></Table.HeaderCell>            <Table.HeaderCell>{t("space_cancelation_date")}<br /><span className="text_date_format">(dd-mm-yyyy)</span></Table.HeaderCell>
            <Table.HeaderCell>{t("space_passenger")}<br /><br /></Table.HeaderCell>
            <Table.HeaderCell>{t("space_flight")}<br /><br /></Table.HeaderCell>
            <Table.HeaderCell>Crucero<br /> <span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Comisión<br /> <span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Vuelo<br /> <span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Descuento Adicional <br /> <span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
            <Table.HeaderCell>Total<br /> <span className="text_date_format">{"(USD)"}</span></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {spaceStateCustom.spacesCanceled.map((space) => (
          <Table.Body>
            <Table.Row align="center">
              <Table.Cell className="font-semibold">{space.id} <br />
                <span className="text_date_format uppercase">
                  <StateCell space={space} />
                </span>
                <span className="text_date_format  uppercase">{space.include_flight_ticket ? 'Incluye ticket aereo' : 'No Incluye ticket aereo'}</span>
              </Table.Cell>
              <Table.Cell>{space.user}</Table.Cell>
              <Table.Cell>{space.creation_date}</Table.Cell>
              <Table.Cell>{space.date_cancellation}</Table.Cell>
              <Table.Cell><PassengerCellCanceledSpace space={space} cruise_id={cruise_id} reservation_id={reservation_id} booking_id={booking_id} /></Table.Cell>
              <Table.Cell><FlightCellCanceledSpace space={space} cruise_id={cruise_id} reservation_id={reservation_id} booking_id={booking_id} /></Table.Cell>
              <Table.Cell>{space.price}
                <br /><span className="text_date_format uppercase">{space.rate}</span>
                {space.tour_leader ? <> <br /><span className="text_date_format uppercase">Tour Leader</span></> : ''}
              </Table.Cell>
              <Table.Cell>- {space.commission_price}<br /><span className="text_date_format">{space.commission_percentage}%</span></Table.Cell>
              <Table.Cell>
                <div className="flex gap-1 justify-center items-center">
                  <p className={`${space.include_flight_ticket ? "line-through" : ''} m-0 `} >
                    {(!space.space_flight_ticket && !space.include_flight_ticket && space.flights) ? 'N/A' : space.flight_price}
                  </p>
                </div>
              </Table.Cell>
              <Table.Cell>{space.special_discount_price}</Table.Cell>
              <Table.Cell><b><div style={{ color: "#1261A0" }}>{space.total_price}</div></b><span className="text_date_format">Operadora: {space.operator_price}</span></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan="1" warning><b>{t("space_cancelation_reason")} :</b></Table.Cell>
              <Table.Cell colSpan="11" warning>{space.reason_cancellation}</Table.Cell>
            </Table.Row>
          </Table.Body>
        ))}
      </Table>
      <SelectedRateSpaceModal
        rateValues={findRatesState}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        onSubmitModalForm={onSubmit}
      />
      <Accordion styled style={{ width: "100vw" }}>
        <Accordion.Title onClick={handleHistoyClick} style={{ display: "flex", gap: "5px" }}>
          {t("log_historical")}
          {openHistory ? <ExpandLess /> : <ExpandMore />}
        </Accordion.Title>
        {spaceLogState.fetching ? (
          <div style={{ display: "flex", width: "100vw", height: "80px", justifyContent: "center" }}>
            <Loader size="medium" active inline>Loading...</Loader>
          </div>
        ) : (
          <Collapse in={openHistory} timeout="auto" unmountOnExit style={{ padding: "15px" }}>
            <LogsHistory
              logsHistory={spaceLogState.logs}
            />
          </Collapse>
        )}
      </Accordion>
    </>
  );
}
